/*
<el-dialog title=""
           :visible.sync="visibleValue"
           :close-on-press-escape="false"
           :close-on-click-modal="false"
           @closed="closedCallback">
</el-dialog>
 */
/**
 * el-dialog 公共关闭配置
 * @type {{data(): *, watch: {visible(*): void, visibleValue(*=): void}, created(): void, methods: {closedCallback(): void}, props: {visible: {default: boolean, type: BooleanConstructor}}}}
 */
export let templateDialog = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      /* 编辑弹窗 */
      visibleValue: false,
    }
  },
  created() {
    this.visibleValue = !!this.visible;
  },
  methods: {
    /**
     * 关闭回调
     */
    closedCallback() {
      if (typeof this.closed === 'function') this.closed();
      this.$emit('closed');
    },
  },
  watch: {
    visible(newValue) {
      this.visibleValue = newValue
    },
    visibleValue(newValue) {
      this.$emit('update:visible', newValue)
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/QuotationManagement/components-productQuotation/templateDialog.js